import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { INews_Item } from '@shared/constants/models.const';
import { NewsSectionComponent } from '../news-section/news-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';

@Component({
  selector: 'app-latest-news-section',
  imports: [
    NewsSectionComponent,
    TranslateModule,
    SeeAllComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './latest-news-section.component.html',
  styleUrl: './latest-news-section.component.scss',
})
export class LatestNewsSectionComponent {
  data = input<INews_Item[]>();
  showSeeAllButton = input<boolean>(true);
  showShortTitle = input<boolean>(false);
  showTitle = input<boolean>(true);
  sectionTitle = input<string>('Latest News');
  customDateField = input<string>('');
  protected readonly ButtonTypes = BUTTON_TYPES;
  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;

  constructor(
    public HELPER: HelperService,
  ) {
  }

}
